export default __webpack_public_path__ + "static/media/about.587c9b79.png";